import { createReducer } from '@reduxjs/toolkit';
import { initialTicketState as initialState } from './state';
import * as actions from './action';
import { setNestedField } from '../utils';

export default createReducer(initialState(), (builder) => {
  builder
    .addCase(actions.setTicket, (state, { payload: { field, value } }) => {
      setNestedField(state, field, value);
    })
    .addCase(actions.resetTicket, (state) => {
      return initialState();
    });
});
